(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Grafika"] = factory();
	else
		root["Grafika"] = factory();
})(this, function() {
return webpackJsonpGrafika([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3);


/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(4);
	
	var _canvas = __webpack_require__(6);
	
	var Canvas = _interopRequireWildcard(_canvas);
	
	__webpack_require__(109);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _window = window;
	var Cx = _window.Cx;
	
	
	(0, _lodash.assign)(Cx, Canvas);

/***/ },

/***/ 6:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _canvas = __webpack_require__(7);
	
	Object.keys(_canvas).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _canvas[key];
	    }
	  });
	});
	
	var _materialCanvas = __webpack_require__(108);
	
	Object.keys(_materialCanvas).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _materialCanvas[key];
	    }
	  });
	});

/***/ },

/***/ 7:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Canvas = exports.StaticCanvas = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	__webpack_require__(102);
	
	__webpack_require__(105);
	
	__webpack_require__(106);
	
	__webpack_require__(107);
	
	var StaticCanvas = exports.StaticCanvas = _view.View.extend(_view.View2D_Mixin).extend(_view.DocumentView_Mixin).extend(_view.SelectedFigures_Mixin).extend(_cdl.FigureConditions_Mixin).extend({
	
	  typeName: 'StaticCanvas',
	
	  Properties: {
	
	    mainDocument: { type: 'Document', def: null, owned: false, set: function (v) {
	        this._setDoc(v);
	      }
	    },
	
	    background: { type: 'Document', def: null, owned: false, set: function (v) {
	        this._setBackground(v);
	      }
	    },
	
	    allowMultiDocumentSelection: { type: 'boolean', def: false }
	
	  },
	  postResize: function () {
	    if (_config.Config.keepLowerLeftCornerAsOrigin) {
	      this.centerPages(this.viewCenter);
	    }
	  },
	
	  get document() {
	    return this._document;
	  },
	  set document(doc) {
	    this._setDoc(doc);
	  },
	
	  zoomToFit$: function () /* ...params */{
	    return this.zoomToFitFigures$.apply(this, arguments);
	  },
	  resetToOrigin: function () {
	    this.zoomPages(1);
	    this.centerPages(this.viewCenter);
	  },
	
	  // [TODO] Allow apps to better configure addition using general filters
	
	  add: function (figures, config) {
	    var selector = config && config.layer || this.destinationLayerSelector;
	    if (selector) {
	      this.setActiveLayerBy(selector);
	    }
	    return this.callParent(figures, config);
	  },
	
	
	  // Allow Multi Document Selection
	  figureAtPointEx: function (docPoint, tabFigures) {
	    if (this._allowMultiDocumentSelection && !this._document.editingContent()) {
	      return this.topFigureFromEx(this.activeSelectableFiguresForDoc(this._mainDocument), docPoint, tabFigures) || this.topFigureFromEx(this.activeSelectableFiguresForDoc(this._background), docPoint, tabFigures);
	    } else {
	      return this.callParent(docPoint, tabFigures);
	    }
	  },
	  getBrushAtPoint: function (docPoint) {
	    var lFigure = this.brushHitTest(this.activeSelectableFiguresForDoc(this._mainDocument), docPoint) || this.brushHitTest(this.activeSelectableFiguresForDoc(this._background), docPoint);
	
	    if (lFigure != null && lFigure.tight) {
	      if (lFigure.polyregion != null && lFigure.polyregion.brush != null && !lFigure.polyregion.brush.empty()) return lFigure.polyregion.brush;
	
	      return lFigure.figure ? lFigure.figure.brush : null;
	    }
	
	    return null;
	  },
	  brushHitTest: function (fromFigures, docPoint) {
	    var figures = (0, _gear.filterRight)(fromFigures, function (figure) {
	      return figure.frame_().contains(docPoint);
	    });
	    var candidates = (0, _lodash.map)(figures, function (figure) {
	      return { figure: figure, docPoint: docPoint, tight: false, polyregion: null };
	    });
	    return this.brushPerformHitTest(candidates);
	  },
	  brushPerformHitTest: function (candidates) {
	    if (candidates.length === 0) {
	      return null; // Nothing around
	    }
	    var candidate = this.brushCheckCandidates(candidates);
	    if (candidate) {
	      candidate.tight = true;
	      return candidate;
	    }
	    return null;
	  },
	  brushCheckCandidates: function (candidates) {
	    for (var k = 0, kEnd = candidates.length; k < kEnd; ++k) {
	      var candidate = candidates[k];
	      var lOptions = { frameBased: false };
	      if (this.figureView(candidate.figure).hitTest(candidate.docPoint, lOptions)) {
	        candidate.polyregion = lOptions.polyregionHit;
	        return candidate;
	      }
	    }
	  },
	  setActiveLayerBy: function (selector) {
	    var doc = this._mainDocument,
	        layer = doc.activePage.layerBy(selector);
	    if (!layer) {
	      doc = this._background;
	      layer = doc.activePage.layerBy(selector);
	    }
	
	    if (layer) {
	      this.activeDocument = doc;
	      this.activeLayer = layer;
	    }
	    return this;
	  },
	
	
	  // [TODO] insertViewPlugins
	
	  drawPage: function (page, context, transform, config) {
	    var _this = this;
	
	    page.forEachFigure(function (figure) {
	      _this.figureView(figure).draw(context, transform, config);
	    });
	  },
	  redrawFigure: function (figure) {
	    this.renderer.redrawFigure(this, figure);
	  },
	  mapToFigureViews: function (figures) {
	    return this.figureViews.mapToFigureViews(figures);
	  },
	  figureView: function (figure) {
	    return this.figureViews.get(figure);
	  },
	  init: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    this.addEvents('brushselected', 'activedocumentchanged', 'newdocument', 'newbackground');
	
	    this._bind('zoomToFit$')._bind('zoomToFitPages$');
	
	    this.figureViews = new _view.SyncedFigureViews({ view: this });
	
	    this.pageViewTransforms = new WeakMap();
	
	    // Broadcast the first view for debugging
	    var Debug = _config.Config.Debug;
	    if (Debug && !Debug.canvas) {
	      Debug.canvas = this;
	    }
	
	    this.callParent(config);
	
	    // Keep this at the end of the init function, because events are triggered
	    // that needs all Mixins to be already initialized
	    this._setBackground(new _cdl.Document());
	    this._setDoc(new _cdl.Document());
	  },
	
	
	  // Intiatilization of documents and DocumentView interaction
	  //----------------------------------------------------------------------------
	  // The docs are linked to the figureViews here, the active document events
	  // are linked directly in activeDocument
	
	  get activeDocument() {
	    return this._document;
	  },
	  set activeDocument(doc) {
	    var oldDoc = this._document;
	    if (oldDoc !== doc) {
	      if (oldDoc) {
	        this.unlinkDoc(oldDoc);
	      }
	
	      this._activeDocumentChanged = true;
	
	      // assert( v === this._mainDocument || v === this._background );
	      this._document = doc;
	      this.selectedFigures._clear();
	
	      this.linkDoc(doc);
	      this.fireEvent('activedocumentchanged', doc);
	    }
	  },
	
	  otherDocFor: function (doc) {
	    return doc === this._mainDocument ? this._background : this._mainDocument;
	  },
	  otherDocPageFor: function (page) {
	    return page.document === this.mainDocument ? this.backgroundPageFor(page) : this.mainDocumentPageFor(page);
	  },
	  fireChangeEvents: function (type, doc) {
	    var _activeDocumentChanged = this._activeDocumentChanged;
	
	    this._activeDocumentChanged = false;
	
	    return this.callParent(type, doc) || _activeDocumentChanged;
	  },
	  _setDoc: function (doc) {
	    var oldDoc = this._mainDocument;
	    if (oldDoc) {
	      this._unlinkMainDoc(oldDoc);
	    }
	    this._mainDocument = doc;
	    // Keep the main document as the active document
	    if (!this._document || this._document === oldDoc) {
	      this.activeDocument = doc;
	    }
	    this._linkMainDoc(doc);
	    if (_config.Config.keepLowerLeftCornerAsOrigin) {
	      this.centerPages(this.viewCenter);
	    }
	    this.fireEvent('newdocument', this, doc, oldDoc);
	  },
	  _linkMainDoc: function (doc) {
	    this.figureViews.link(doc);
	    this.on_pageschanged(doc, doc.pages);
	    this.on_activepagechanged(doc, doc.activePage);
	  },
	  _unlinkMainDoc: function (doc) {
	    this.figureViews.unlink(doc);
	  },
	  _setBackground: function (doc) {
	    var oldDoc = this._background;
	    if (oldDoc) {
	      this._unlinkBackground(oldDoc);
	    }
	    this._background = doc;
	    this._linkBackground(doc);
	    this.fireEvent('newbackground', this, doc, oldDoc);
	  },
	  _linkBackground: function (doc) {
	    this.figureViews.link(doc);
	  },
	  _unlinkBackground: function (doc) {
	    this.figureViews.unlink(doc);
	  },
	  dispose: function () {
	    this._unlinkBackground(this.background);
	    this._unlinkMainDoc(this.mainDocument);
	    this.callParent();
	  },
	  redrawDoc: function () {
	    this.redraw('document', 'background'); // [TODO] Hack for demo, not needed
	
	    /*
	    if( this.doc === this.mainDocument ) {
	      this.redraw('document');
	    }
	    else {
	      this.redraw('background');
	    }
	    */
	  },
	
	
	  // Syncronization between mainDocument and background
	  //---------------------------------------------------------------------------------------
	
	  on_rendercomplete: function (doc) {
	    // If the document was commited, also issue a render of the other doc because Canvas
	    // promises that everything is going to get rendered after that (if not we could have
	    // bugs with patterns like change doc > zoom to fit doc > doc.commit$
	    this.otherDocFor(doc).render$();
	    this.callParent.apply(this, arguments);
	  },
	  on_activepagechanged: function (doc, page) {
	    this.otherDocFor(doc).activePage = this.otherDocPageFor(page);
	    this.viewTransform = this.pageViewTransform(this.mainDocument.activePage);
	    this.callParent(doc, page);
	  },
	
	
	  // [TODO] Add options for different background/mainDocument setups
	  //        Avoid assuming an structure. Directly provide Apps configuration
	  //        points to decide how pages are syncronized. For some applications
	  //        the background pages may be totally independent of the main document
	
	  backgroundPageFor: function (page) {
	    var background = this._background;
	    var backgroundPages = background._pages;
	    var pageId = page._id;
	
	    var backgroundPage = pageId !== null ? (0, _lodash.find)(backgroundPages, { id: page.id }) : null;
	    if (!backgroundPage) {
	      var pages = this._mainDocument._pages;
	      backgroundPage = backgroundPages[Math.min(pages.indexOf(page), backgroundPages.length - 1)];
	    }
	    return backgroundPage;
	  },
	  mainDocumentPageFor: function (page) {
	    var mainDocument = this._mainDocument;
	    var mainDocumentPages = mainDocument._pages;
	    var pageId = page._id;
	
	    var mainDocumentPage = pageId !== null ? (0, _lodash.find)(mainDocumentPages, { id: page.id }) : null;
	    if (!mainDocumentPage) {
	      var pages = this._background._pages;
	      mainDocumentPage = mainDocumentPages[Math.min(pages.indexOf(page), mainDocumentPages.length - 1)];
	    }
	    return mainDocumentPage;
	  },
	
	
	  // Page independent view transforms
	  //--------------------------------------------------------------------------------
	
	  // [TODO] We could use getState/setState to store the viewTransform for each page
	
	  getZoomToFitFigures: function () {
	    return this.visibleCrossDocumentPageFiguresOf(this.activePage);
	  },
	  visibleCrossDocumentPageFiguresOf: function (page) {
	    var figures = page.visibleFigures;
	    var backgroundPage = this.backgroundPageFor(page);
	    return backgroundPage ? figures.concat(backgroundPage.visibleFigures) : figures;
	  },
	  zoomToFitPages$: function () {
	    var _this2 = this;
	
	    var margin = arguments.length <= 0 || arguments[0] === undefined ? this._defaultMargin() : arguments[0];
	
	    return (0, _gear.map$)(this._mainDocument._pages, function (page) {
	      var figures = _this2.visibleCrossDocumentPageFiguresOf(page);
	      return _cdl.Figures.bounds$(figures).then(function (bounds) {
	        _this2.pageViewTransform(page).zoomAround(_this2, bounds, margin);
	      });
	    }).then(function () {
	      return _this2.on_zoomupdated();
	    });
	  },
	  zoomPages: function (zoom) {
	    var _this3 = this;
	
	    (0, _lodash.forEach)(this.mainDocument.pages, function (page) {
	      _this3.pageViewTransform(page).zoom = zoom;
	    });
	    this.on_zoomupdated();
	    return this;
	  },
	  centerPages: function (center) {
	    var _this4 = this;
	
	    (0, _lodash.forEach)(this._mainDocument._pages, function (page) {
	      _this4.pageViewTransform(page).center = new _cdl.Point(center);
	    });
	    this.on_zoomupdated();
	    return this;
	  },
	  pageViewTransform: function (page) {
	    var viewTransform = this.pageViewTransforms.get(page);
	    if (!viewTransform) {
	      viewTransform = this.pageViewTransforms.get(this.otherDocPageFor(page));
	    }
	    return viewTransform;
	  },
	  setPageViewTransform: function (page, viewTransform) {
	    this.pageViewTransforms.set(page, viewTransform);
	  },
	
	
	  // [TODO]
	  // This can be improved by linking pages when commiting ( undoPage, redoPage links )
	  // That will allow to even preserve zooming when adding or deleting pages
	  // and could simplify a lot of this code
	
	  on_pageschanged: function (doc, added, removed) {
	    var _this5 = this;
	
	    if (added) {
	      (0, _lodash.forEach)(added, function (page) {
	        if (!_this5.pageViewTransform(page)) {
	          _this5.setPageViewTransform(page, new _view.ViewTransform());
	        }
	      });
	    }
	    if (removed) {
	      (0, _lodash.forEach)(removed, function (page) {
	        return _this5.pageViewTransforms.delete(page);
	      });
	    }
	    this.callParent(doc, added, removed);
	  },
	  on_historycommitstarted: function (doc, waitFor, type) {
	    var _this6 = this;
	
	    this._undoRedoViewTransform = (0, _gear.cloneDeep)((0, _lodash.map)(doc.pages, function (page) {
	      return _this6.pageViewTransform(page);
	    }));
	    this.callParent(doc, waitFor, type);
	  },
	  on_undo: function (doc) {
	    this.onUndoRedoRevert(doc);
	    this.callParent.apply(this, arguments);
	  },
	  on_redo: function (doc) {
	    this.onUndoRedoRevert(doc);
	    this.callParent.apply(this, arguments);
	  },
	  on_revert: function (doc) {
	    this.onUndoRedoRevert(doc);
	    this.callParent.apply(this, arguments);
	  },
	  onUndoRedoRevert: function (doc) {
	    var _this7 = this;
	
	    var pages = doc.pages;
	
	    if (this._undoRedoViewTransform.length === pages.length) {
	
	      // Pages have not change, maintain zoom for them
	      (0, _lodash.forEach)(pages, function (page, k) {
	        _this7.setPageViewTransform(page, _this7._undoRedoViewTransform[k]);
	      });
	
	      this.viewTransform = this.pageViewTransform(doc.activePage);
	      this._undoRedoViewTransform = [];
	
	      this.render$();
	    } else {
	      this.zoomToFitPages$().then(this.render$);
	    }
	  }
	});
	
	var Canvas = exports.Canvas = StaticCanvas.extend(_view.InteractiveView_Mixin).extend({
	
	  typeName: 'Canvas',
	
	  Properties: {
	
	    // [TODO] Use conditions
	    // dblclickContentEditionEnabled: { type: 'function', def(/*figure*/) { return true; } },
	  },
	
	  createRenderers: function () {
	    return [_view.Plugin.ActiveRenderer()];
	  },
	
	
	  // [TODO] Work in progress to properly separate Static and Interactive Canvas
	
	  insertViewPlugins: function (plugins) {
	
	    var renderPlugins = _config.Config.useSpecialPens ? [_view.Plugin.SpecialPens()] : [];
	
	    plugins.insert(0, renderPlugins.concat(this.createRenderers()).concat([_view.Plugin.ViewControls(), _view.Plugin.PluginsLayer(), _view.Plugin.AlignmentLines(), _view.Plugin.FigureAnnotations(), _view.Plugin.Tools()]));
	  }
	});

/***/ },

/***/ 108:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MaterialCanvas = undefined;
	
	var _config = __webpack_require__(2);
	
	var _view = __webpack_require__(84);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _canvas = __webpack_require__(7);
	
	/* globals THREE */
	
	function createAboveSceneCamera(width, height) {
	  return new THREE.OrthographicCamera(-width / 2, width / 2, height / 2, -height / 2, 0, 30);
	}
	
	function updateAboveSceneCamera(camera, width, height) {
	  camera.left = width / -2;
	  camera.right = width / 2;
	  camera.top = height / 2;
	  camera.bottom = height / -2;
	  camera.updateProjectionMatrix();
	}
	
	// [TODO] Plugin.TextureImage({ textureType: 'normal', src: ... })
	
	_view.Plugin.NormalMapImage = _view.Plugin.extend({ typeName: 'NormalMapImage',
	
	  target: 'document',
	  drawTo_normal: ['normal'],
	
	  Properties: {
	    src: { type: 'string', def: 'texture.jpg' }
	  },
	
	  initPlugin: function (view) {
	    var _this = this;
	
	    (0, _gear.imagePromise)(this.src).then(function (image) {
	      _this.image = image;
	      view.redraw('normal');
	      console.log('loaded');
	    });
	  },
	  draw: function (_ref) {
	    var context = _ref.context;
	    var transform = _ref.transform;
	    var image = this.image;
	
	    if (!image) {
	      return;
	    }
	    context.save();
	    var canvas = context.canvas;
	
	    context.rect(0, 0, canvas.width, canvas.height);
	    _cdl.Matrix.m(transform, _cdl.Matrix.scale(_config.Config.materialScale || 0.2)).transformContext(context);
	    context.fillStyle = context.createPattern(image, 'repeat');
	    context.fill();
	    context.restore();
	  }
	});
	
	var MaterialCanvas = exports.MaterialCanvas = _canvas.Canvas.extend({ typeName: 'MaterialCanvas',
	
	  Properties: {},
	
	  createTextures: function () {
	    return [new _view.TextureComposition({ textureType: 'normal' }), new _view.TextureComposition({ textureType: 'color' })];
	  },
	  createScene: function () {
	    return new _view.Composition({ textureType: '3D', main: true });
	  },
	  createRenderers: function () {
	    return this.callParent().concat([_view.Plugin.NormalMapImage({ src: 'texture-' + (_config.Config.material || 1) + '.jpg' }), _view.Plugin.Renderer3D()]);
	  },
	  init: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    window.canvas = this;
	    this.callParent(config);
	    this.initThreeScene();
	  },
	  initThreeScene: function () {
	    var _this2 = this;
	
	    var threeScene = this.threeScene = new THREE.Scene();
	
	    var width = this.width;
	    var height = this.height;
	
	    this.camera = createAboveSceneCamera(width, height);
	
	    this.createDrawingSurface();
	
	    var light = this._light = new THREE.HemisphereLight(0xaaaaaa, 0x808080, 0.5);
	    threeScene.add(light);
	    light.position.set(200, 200, 300);
	
	    var light3 = new THREE.PointLight(0xaaaaaa, 0.5);
	    light3.position.set(150, 150, 500);
	    threeScene.add(light3);
	
	    var light2 = new THREE.PointLight(0xaaaaaa, 0.5);
	    light2.position.set(0, 850, 850);
	    threeScene.add(light2);
	
	    var clamp = function (v) {
	      var d = 400;
	      return Math.min(Math.max(v, -d), d);
	    };
	    document.addEventListener('mousemove', function (event) {
	      var width = _this2.width;
	      var height = _this2.height;
	
	      var p = _this2.viewPoint(event);
	      light2.position.set(clamp(p.x - width / 2, 20), 850, 850 + clamp(p.y - height / 2));
	      _this2.redraw('3D');
	    }, false);
	  },
	  createDrawingSurface: function () {
	    // There is an issue with updating the texture of the plane geometry
	    // For the prototype, I just recreate the scene but we need to fix this
	    // to improve performance
	    this.updateDrawingSurface();
	  },
	  updateDrawingSurface: function () {
	
	    if (this._documentPlane) {
	      this.threeScene.remove(this._documentPlane);
	      this._documentGeometry.dispose();
	      this._documentMaterial.dispose();
	    }
	
	    var material = this._documentMaterial = new THREE.MeshPhongMaterial({
	
	      map: this.texture('color').threeTexture,
	      normalMap: this.texture('normal').threeTexture,
	
	      // color      :  new THREE.Color("rgb(155,196,30)"),
	      emissive: new THREE.Color("#" + (_config.Config.emissive || "222222")),
	      specular: new THREE.Color("#" + (_config.Config.specular || "888888")),
	      shininess: _config.Config.shininess || 10
	    });
	
	    material.transparent = true;
	
	    var _texture$composedCanv = this.texture('color').composedCanvas;
	    var width = _texture$composedCanv.width;
	    var height = _texture$composedCanv.height;
	
	    var planeGeometry = this._documentGeometry = new THREE.PlaneBufferGeometry(width, height);
	
	    var plane = this._documentPlane = new THREE.Mesh(planeGeometry, material);
	
	    console.log(this.height - height);
	    console.log(width - this.width);
	    plane.position.set((width - this.width) / 2, -(height - this.height) / 2, 0);
	
	    this.threeScene.add(plane);
	  },
	  on_rendercomplete: function () {
	    this.redraw('3D');
	    this.callParent.apply(this, arguments);
	  },
	  updateSize: function (width, height) {
	    this.callParent(width, height);
	    this.updateDrawingSurface();
	
	    updateAboveSceneCamera(this.camera, this.width, this.height);
	  },
	  draw3D: function (renderer) {
	    console.log('draw 3D');
	
	    renderer.render(this.threeScene, this.camera);
	  }
	});

/***/ }

})
});
;


/** WEBPACK FOOTER **
 ** canvas.js
 **/